import React from "react";
import image from "../../assets/images/dean-bqs2.jpg";

export default function DeanResearch() {
  return (
    <>
      <section
        className="section"
        style={{
          position: "relative",
          top: "185px",
          marginBottom: "20vh",
          marginTop: "10vh",
          padding: "2rem",
        }}
      >
        <div className="centered-image">
          <div>
            <h1 style={{ textAlign: "center" }}>Dean BQS</h1>
            <h2 style={{ textAlign: "center" }}>Dr.Nilani.P</h2>
          </div>
          <div>
            <img
              src={image}
              alt=""
              style={{
                width: "100%",
                height: "100%",
                minWidth: "300px",
                minHeight: "200px",
                maxWidth: "600px",
                maxHeight: "400px",
              }}
            />
          </div>
        </div>
        <br />
        <div style={{ textAlign: "center", marginTop: "30px" }}>
          <p>deanbqs@jssuninoida.edu.in</p>
        </div>
        <br />
        <p
          className=""
          style={{
            textAlign: "justify",
            fontSize: "1.2em",
          }}
        >
          At JSS University, Noida, we believe that quality and sustainability
          are not just goals but foundational principles that define our
          academic and institutional vision. As a young and dynamic university
          nurtured by the visionary legacy of JSS Mahavidyapeetha (MVP), we are
          committed to building a future-ready ecosystem that aligns academic
          excellence with environmental responsibility and social relevance. JSS
          Mahavidyapeetha, with its decades-long tradition of excellence in
          education, social service, and spiritual values, continues to inspire
          and guide us. Its enduring commitment to inclusive growth, human
          welfare, and nation-building serves as the bedrock for our initiatives
          in quality enhancement and sustainable development. Our approach to
          quality focuses on continuous improvement through rigorous academic
          planning, transparent governance, and stakeholder engagement. We are
          implementing robust internal quality assurance mechanisms, curriculum
          reforms aligned with NEP 2020, and faculty development initiatives to
          nurture a culture of innovation and inquiry. Our commitment is
          reflected in the development of interdisciplinary programs,
          outcome-based education, and the integration of Indian Knowledge
          Systems to foster holistic learning. Sustainability, for us, is a way
          of life and learning. Our green campus initiatives, energy-efficient
          infrastructure, and commitment to responsible resource use reflect our
          broader vision for environmental stewardship. We are actively
          promoting community engagement, rural outreach, and research in
          sustainable development to prepare our students as responsible global
          citizens. With the guiding light of JSS Mahavidyapeetha and the
          collective spirit of our university community, JSS University is
          confidently progressing toward becoming a national model in quality
          and sustainability.
          <br />
          <br />
          Dr.Nilani.P
          <br />
          Dean BQS
          <br />
          JSS University, Noida
        </p>
      </section>
    </>
  );
}
